import { useEffect } from "react";

const Card = ({ img, title, price }) => {

  return (
    <div className="flex flex-col md:gap-[24px] gap-[16px]">
      <img
        src={img}
        alt=""
        className="max-w-[390px] max-h-[520px] w-full h-full"
      />
      <div className="flex flex-col">
        {/* name */}
        <span className="text-[#303739] text-[14px] tracking-[0.56px] md:tracking-[0.48px] leading-[18px] md:text-[24px] md:leading-[30px]">
          {title}
        </span>

        {/* price */}
        <span className="text-[#979099] text-[14px] tracking-[0.56px] md:tracking-[0.48px] leading-[18px] md:text-[24px] md:leading-[30px]">
          ${price}
        </span>
      </div>
    </div>
  );
};

export default Card;
